<!--可查看svg图形树-->
<template>
	<div class="my-svg-tree">
		<!-- <div class="elTree_hideButton">
			<div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
			</div>
			<div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
			</div>
		</div> -->
	
		
		 <div style="margin-bottom: 5px;">
            <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        </div>
		<el-scrollbar style="height:calc(100% - 55px);width: 100%;">
			<el-tree accordion :expand-on-click-node="false" 
			default-expand-all :data="dataList" 
			node-key="id" :current-node-key='defaultSvg.id' 
			:highlight-current='true'
			:props="defaultProps" :filter-node-method="filterNode" 
			ref="tree" @node-click="nodeClick">
				<span class="custom-tree-node" slot-scope="{node}">
					<img src="../../../../public/static/image/elTree/1.9.png" v-show="node.data.entityName=='UsePowerUnit'"/>
					<img src="../../../../public/static/image/elTree/2.4.png" v-show="node.data.entityName=='Page'"/>
					<span style="padding-left: 5px;">{{node.label }}</span>
				</span>
			</el-tree>
		</el-scrollbar>


	</div>
</template>

<script>
	import tree from './tree.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			tree
		},
		props: [],
		data() {
			return {
				filterText: '',
				nowCheckId: '',
				nowCheckItem: {},
				nowOpenFloorIds: [],
				playStatus: false,
				seconds: 20,
				nowIndex: -1,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				defaultSvg: '',
				svgDataList: [],
				isShow: true,
				conformArr:[]
			}
		},
		created() {},
		mounted() {
			this.diguiFilter(this.nowUnit.id, [this.getSvgTree])
			//加载以后默认选中第一个设备
			this.checkFirst(this.dataList)
			this.digui(this.dataList)
		},
		destroyed() {
			this.stopChange()
		},
		computed: {
			bodyStyle() {
				let width = '0px'
				if(this.isShow) {
					width = '2.5rem'
				}
				return {
					"width": width
				}
			},
			dataList() {
				var data = this.svgDataList
				return isempty(data) ? [] : svgList([data])
			},
			svgList() {
				if(this.dataList[0] == undefined) {
					return []
				}
				return treeToList(this.dataList[0], 'next', item => item.hasOwnProperty('next')).filter(item => item.entityName ==
					'Page')
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getSvgTree() {
				return this.$store.svgStore.getters.getSvgTree
			},
			
		},
		watch: {
			getSvgTree(nv, ov) {
				this.diguiFilter(this.nowUnit.id, [this.getSvgTree])
			},
			dataList(nv, ov) {
				/*if(isempty(ov[0])) {*/
				this.digui(nv)
				/*}*/
			},
			nowCheckItem(nv, ov) {
				this.$emit("checkItem", nv)
				this.nowIndex = this.svgList.findIndex(item => nv.path == item.path)
			},
			seconds(nv, ov) {
				this.stopChange()
				if(isempty(nv) || parseInt(nv) != this.seconds) {
					if(isempty(ov)) {
						this.seconds = parseInt(nv)
					} else {
						this.seconds = ov
					}
				}
				if(nv < 10) {
					this.seconds = 10
					this.$dialogMethod.showMessage("最小间隔为10秒!")
				}

			},
			defaultSvg(nv, ov) {
				console.log("树形结构",nv);
				if(nv != undefined){
					this.$nextTick(()=>{
						//默认选中
						this.$refs['tree'].setCurrentKey(nv.id);
					})
					var nowSvg = this.$store.svgStore.state.nowSvgItem
					if(nowSvg == undefined){
						this.$store.svgStore.commit('getNowSvg',nv)
					}
			    	this.$emit('checkItem', nv)
				}
			},
			nowUnit(nv, ov) {
				this.diguiFilter(nv.id, [this.getSvgTree])
			},

			
		},
		methods: {
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick(value, nodeData) {
				value.name = value.label
				if(value.entityName == "Page") {
					// this.$store.svgStore.commit('getNowSvg',value)
					this.$emit('checkItem', value)
				}
			},
			checkFirst(dataList) {
				if(isempty(dataList)) {
					return
				}
				//递归打开层级直到找到第一个设备
				var obj = this.findDevice(this.dataList)
				if(obj == undefined) {
					return
				}
				this.nowOpenFloorIds = obj.floor
				this.nowCheckId = this.getIdMethod(obj.device)
				this.nowCheckItem = obj.device
			},
			imgMethod(item) {
				switch(item.entityName) {
					case "UsePowerUnit":
						return resourcesStore.getters.getResourcesByName("tree/node_unit.png")
					case "Page":
						return resourcesStore.getters.getResourcesByName("tree/node_dev.png")
					default:
						return 'resourcesStore.getters.getResourcesByName("tree/node_class.png")'
				}
			},
			getIdMethod(item) {
				switch(item.entityName) {
					case "Page":
						return item.path
					default:
						return item.id
				}
			},
			checkItem(item) {
				this.nowCheckId = this.getIdMethod(item)
				this.nowCheckItem = item
			},
			// 开始自动切换
			startChange() {
				this.stopChange()
				// 添加定时任务
				this.playStatus = true
				addNewTask('changeSvgTimer', this.seconds * 1000, this.seconds * 1000, -1, () => {
					if(this.nowIndex == this.svgList.length - 1) {
						this.checkItem(this.svgList[0])
					} else {
						this.checkItem(this.svgList[this.nowIndex + 1])
					}
				})
			},
			findDevice(dataList) {
				var list = []
				for(var i = 0, len = dataList.length; i < len; i++) {
					var item = dataList[i]
					if(item.entityName == 'Page') {
						//是设备,返回吧
						return {
							device: item,
							floor: []
						}
					} else if(!isempty(item.next)) {
						//找一下下级
						var obj = this.findDevice(item.next)
						if(obj != undefined) {
							//找到了,把自己的id也加进去
							obj.floor.push(this.getIdMethod(item))
							return obj
						}
					}
				}
			},
			stopChange() {
				this.playStatus = false
				removeTask('changeSvgTimer')
			},
			listenKeydown(ev) {
				if(ev.keyCode == 109 || ev.keyCode == 110 || ev.keyCode == 190 || ev.keyCode == 229) {
					ev.preventDefault()
				}
			},
			digui(list) {
				this.conformArr = []
				var nowItem = this.$store.svgStore.state.nowSvgItem
				if(nowItem != undefined){
                     this.defaultSvg   = this.$store.svgStore.state.nowSvgItem
				}else {
                   list.forEach(item => {
						if(!isempty(item.children)) {
							this.digui(item.children)
						} else {
							if(item.entityName == "Page") {
								/*if(isempty(this.defaultSvg)) {*/
								
								this.conformArr.push(item)
								
								/*}*/
							}
						}
					})

					this.defaultSvg = this.conformArr[0]
				}
				
				
			},
			diguiFilter(id, list) {
				list.forEach(item => {
					if(item.id == id) {
						this.svgDataList = item
					} else {
						if(!isempty(item.next)) {
							this.diguiFilter(id, item.next)
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
 .my-svg-tree {
    width: 100%;
    height: 100%;
    .custom-tree-node {
        display: flex;
        align-items: center;
        img {
            margin-right: 1px;
        }
    }
    
  }

</style>
